export * from './InlinePageListItem';

import InlinePageListItem from './InlinePageListItem';
export default InlinePageListItem;
